// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tk-0";